<article>
  <header>
    <h6>{{ header() }}</h6>
  </header>
  <ul class="list-unstyled mb-md-3">
    @for (row of data(); track row; let firstRow = $first) {
      <li class="mb-5 mb-md-0">
        <dl class="row g-2 mb-2">
          @for (column of columns(); track $index) {
            @let columnWidthClass = 'col-md-' + columnWidths()[$index];
            @let columnAlignmentClass = column.type() === ColumnType.DESCRIPTION || $first ? 
              'text-md-start' : 'text-md-end';
            @let columnPaddingClass = column.type() === ColumnType.OPERATION ?
              'pe-md-3' : '';
            @let headerColumnVisibilityClass = !firstRow ? 
              'd-md-none' : column.type() === ColumnType.OPERATION ?
               'invisible text-nowrap': '';
            @let columnClasses = [columnWidthClass, columnAlignmentClass, columnPaddingClass];
            @let headerClasses = [...columnClasses, ...headerColumnVisibilityClass.split(' ')];
            <dt class="col-6 order-md-first fw-regular"
                [class]="headerClasses">
              {{ column?.header() }}
            </dt>
              <dd class="col-6 mb-0 text-end"
                  [class]="columnClasses">
                <ng-container 
                    [ngTemplateOutlet]="column.template" 
                    [ngTemplateOutletContext]="{ $implicit: row }">
                  </ng-container>
              </dd>
          }
        </dl>
      </li>
    }
    @if (discountLabels().length > 0) {
      <li class="mb-5 mb-md-0">
        <dl class="row g-2 mb-2">
          @for (discountLabel of discountLabels(); track $index) {
            <dt class="col-6 col-md-9 text-md-end fw-regular">
                <ng-container [ngTemplateOutlet]="discountLabel.template" />
            </dt>
              <dd class="col-6 col-md-3 mb-0 text-end">
                <ng-container [ngTemplateOutlet]="discountValues()[$index].template" />
              </dd>
          }
        </dl>
      </li>
    }
  </ul>
  <footer class="text-end fw-regular">
    <ng-container [ngTemplateOutlet]="subTotal().template" />
  </footer>
</article>
